import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

// TODO проверить необходимость существования - выпилить?

const mutation = gql`
mutation IntentsResolver($updateSkills: [UpdateSkillInput!]) {
  updateOperatorSkills(updateSkills: $updateSkills)
}`;

function updateOperatorsSkills(updateSkills) {
  return apollo.client.mutate({
    variables: {
      updateSkills,
    },
    mutation,
  }).then((res) => res.data.updateOperatorSkills);
}

export default updateOperatorsSkills;
